import React from 'react';
import ReactMarkdown from 'react-markdown';
import { createStyles } from '@mantine/emotion';

const useStyles = createStyles((theme) => ({
  markdownContainer: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Microsoft YaHei", "PingFang SC", "Hiragino Sans GB", Roboto, "Helvetica Neue", Arial, sans-serif',
    lineHeight: 1.6,
    color: '#333',
    fontSize: '1rem',
    width: '100%',
    maxWidth: '100%',
    overflowWrap: 'break-word',
    overflow: 'hidden',
    '& p': {
      marginBottom: '1.2em',
      textAlign: 'justify',
      lineHeight: 1.7,
      maxWidth: '100%',
      overflowWrap: 'break-word',
      wordBreak: 'break-word',
    },
    '& strong': {
      fontWeight: 'bold',
      color: '#000',
    },
    '& ul, & ol': {
      paddingLeft: '2em',
      marginBottom: '1.2em',
    },
    '& li': {
      marginBottom: '0.6em',
      textAlign: 'justify',
      position: 'relative',
    },
    '& h1, & h2, & h3, & h4': {
      fontWeight: 'bold',
      marginTop: '1.4em',
      marginBottom: '0.8em',
      color: '#222',
    },
    '& h1': {
      fontSize: '1.8em',
      borderBottom: '1px solid #eaecef',
      paddingBottom: '0.3em',
    },
    '& h2': {
      fontSize: '1.5em',
      borderBottom: '1px solid #eaecef',
      paddingBottom: '0.3em',
    },
    '& h3': {
      fontSize: '1.25em',
    },
    '& h4': {
      fontSize: '1em',
    },
    '& blockquote': {
      borderLeft: '4px solid #ddd',
      paddingLeft: '1em',
      color: '#666',
      margin: '0 0 1em 0',
      backgroundColor: '#f9f9f9',
      padding: '0.5em 1em',
    },
    // Optimizations for Chinese/Mandarin text
    '@media screen and (min-width: 768px)': {
      fontSize: '1.05rem',
      lineHeight: 1.8,
    },
  },
  dialogContent: {
    maxHeight: '70vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    width: '100%',
    boxSizing: 'border-box',
    '& ul li::before': {
      content: '"•"',
      position: 'absolute',
      left: '-1.2em',
      color: '#8e24aa',
      fontWeight: 'bold',
    },
    '& ul': {
      listStyleType: 'none',
      paddingLeft: '1.5em',
      width: '100%',
      maxWidth: '100%',
      boxSizing: 'border-box',
    },
    '& p, & li, & h1, & h2, & h3, & h4': {
      paddingRight: '24px',
      maxWidth: '100%',
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
      boxSizing: 'border-box',
    }
  }
}));

const MarkdownRenderer = ({ content, inDialog = false }) => {
  const { classes, cx } = useStyles();

  if (!content) {
    return null;
  }

  return (
    <div className={cx(classes.markdownContainer, { [classes.dialogContent]: inDialog })}>
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
